import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100% ',
};

export const date: SxStyle = {
  display: 'flex',
  gap: (p) => p.spacing(0.5),
};
